export default {"src":"/_next/static/media/Eczema and Dermatitis.a24de452.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};